/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LexplusKundeContractStatusEnum {
  None = 0,
  Open = 1,
  Ok = 2
}
